import {queries} from '@/shared/integrations/zero'
import {useQuery} from '@rocicorp/zero/react'

export function useGetDrugsCategory(id: string | undefined) {
  return useQuery(queries.basicData.getDrugCategoryById(id || ''))
}
